import { 
  collection, 
  query, 
  where, 
  getDocs, 
  addDoc, 
  orderBy, 
  serverTimestamp,
  deleteDoc,
  doc
} from 'firebase/firestore';
import { db, handleFirestoreError, OperationType } from '../firebase';
import { ChatMessage, PlantDiagnosis } from '../types';

export const saveAIChatMessage = async (userId: string, role: 'user' | 'model', text: string, image?: string) => {
  try {
    await addDoc(collection(db, 'ai_advisor_history'), {
      userId,
      role,
      text,
      image: image || null,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    handleFirestoreError(error, OperationType.CREATE, 'ai_advisor_history');
  }
};

export const getAIChatHistory = async (userId: string): Promise<ChatMessage[]> => {
  try {
    const q = query(
      collection(db, 'ai_advisor_history'),
      where('userId', '==', userId)
    );
    const snapshot = await getDocs(q);
    const messages = snapshot.docs.map(doc => ({ 
      ...doc.data(), 
      timestamp: doc.data().timestamp?.toDate() || new Date() 
    } as ChatMessage));

    // Sort in-memory to avoid composite index requirement
    return messages.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
  } catch (error) {
    handleFirestoreError(error, OperationType.LIST, 'ai_advisor_history');
    return [];
  }
};

export const clearAIChatHistory = async (userId: string) => {
  try {
    const q = query(collection(db, 'ai_advisor_history'), where('userId', '==', userId));
    const snapshot = await getDocs(q);
    const deletePromises = snapshot.docs.map(d => deleteDoc(doc(db, 'ai_advisor_history', d.id)));
    await Promise.all(deletePromises);
  } catch (error) {
    handleFirestoreError(error, OperationType.DELETE, 'ai_advisor_history');
  }
};

export const savePlantDiagnosis = async (userId: string, image: string, diagnosis: string) => {
  try {
    await addDoc(collection(db, 'plant_doctor_history'), {
      userId,
      image,
      diagnosis,
      timestamp: serverTimestamp()
    });
  } catch (error) {
    handleFirestoreError(error, OperationType.CREATE, 'plant_doctor_history');
  }
};

export const getPlantDiagnosisHistory = async (userId: string): Promise<PlantDiagnosis[]> => {
  try {
    const q = query(
      collection(db, 'plant_doctor_history'),
      where('userId', '==', userId)
    );
    const snapshot = await getDocs(q);
    const diagnoses = snapshot.docs.map(doc => ({ 
      ...doc.data(), 
      id: doc.id,
      timestamp: doc.data().timestamp?.toDate() || new Date() 
    } as PlantDiagnosis));

    // Sort in-memory to avoid composite index requirement
    return diagnoses.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
  } catch (error) {
    handleFirestoreError(error, OperationType.LIST, 'plant_doctor_history');
    return [];
  }
};
